// import { apiRequest } from '../services/apiRequest'

// export const LibraryApi = {
//   filterSelection: async (data) =>
//     await apiRequest(
//       'get',
//       `/api/decor-styles/?${new URLSearchParams(data).toString()}`
//     ),
//   deleteLibraryImage: async (data) =>
//     await apiRequest('delete', '/api/delete-library-images/', data),
// }

import { api } from "../services/axios"

export const LibraryApi = {
  // 🚫 Unauthenticated GET request
  filterSelection: async (data = {}) => {
    const queryString = new URLSearchParams(data).toString()
    return await api.get(
      `/api/decor-styles/${queryString ? `?${queryString}` : ""}`,
      {
        auth: false, // <== this disables token
      }
    )
  },

  // ✅ Still authenticated by default
  deleteLibraryImage: async (data) =>
    await api.delete("/api/delete-library-images/", { data }),
}
